import { ImageBase64UploadAdapter } from './adapters/base64-upload.adapter';
import { AbstractUploadPlugin } from '.';

export default class ImageBase64Upload extends AbstractUploadPlugin {
    static get pluginName(): string { return ImageBase64Upload.name; }
    public readonly uploadAdapter = ImageBase64UploadAdapter;

    constructor(editor) {
        super(editor);
    }
}
